import { zodResolver } from '@hookform/resolvers/zod';
import { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useMarket from 'stores/useMarket';
import { CustomerLoginFormType } from './types/CustomerLoginFormType';
import { useTranslatedCustomerLoginSchema } from './hooks/useTranslatedCustomerLoginSchema';

type UserLoginFormProviderProps = {
    children: ReactNode;
};

export default function UserLoginFormProvider({ children }: UserLoginFormProviderProps) {
    const { backendDomain, market } = useMarket((state) => ({
        backendDomain: state.backendDomain,
        market: state.market,
    }));

    const translatedCustomerLoginSchema = useTranslatedCustomerLoginSchema();

    const methods = useForm<CustomerLoginFormType>({ resolver: zodResolver(translatedCustomerLoginSchema) });

    const formProps = {
        action: `${backendDomain}/api/authenticate/customerLogin`,
        method: 'post',
    };

    return (
        <FormProvider {...methods}>
            <form {...formProps}>
                <input type="hidden" name="market" value={market} />
                {children}
            </form>
        </FormProvider>
    );
}
